// LIFTED (shim) for bagel-dashboard/src/icons/x-symbol-svgrepo-com.jsx.
//
// FieldMappingDrawer uses 8 decorative field-type icons from that 2,950-line file.
// Rather than extract the raw SVGs (fragile), these are neutral Tabler placeholders.
// TODO(faithful-lift): extract the real SVG blocks from the dashboard file if the exact
// visuals matter. Tracked in plans/copy-integrations.md.
import {
  IconFile,
  IconPhone,
  IconClipboardList,
  IconAlertTriangle,
  IconMessage2,
  IconTicket,
  IconClipboardText,
  IconBuilding,
  type TablerIconsProps,
} from '@tabler/icons';

export const CustomerCallIcon = (props: TablerIconsProps) => <IconPhone {...props} />;
export const GeneralIcon = (props: TablerIconsProps) => <IconFile {...props} />;
export const HealthNotesIcon = (props: TablerIconsProps) => <IconClipboardList {...props} />;
export const LostHoldReasonIcon = (props: TablerIconsProps) => <IconAlertTriangle {...props} />;
export const PmFeedbackIcon = (props: TablerIconsProps) => <IconMessage2 {...props} />;
export const SupportCaseTicketIcon = (props: TablerIconsProps) => <IconTicket {...props} />;
export const SurveyIcon = (props: TablerIconsProps) => <IconClipboardText {...props} />;
export const RequestBusinessnameIcon = (props: TablerIconsProps) => <IconBuilding {...props} />;
